import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import LangSelect from '@/components/LangSelect/index.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "redirect", void 0);
    _defineProperty(_this, "otherQuery", {});
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "onRouteChange",
    value: function onRouteChange(route) {
      // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
      // See https://github.com/vuejs/vue-router/pull/2050 for details
      var query = route.query;
      if (query) {
        this.redirect = query.redirect;
        this.otherQuery = this.getOtherQuery(query);
      }
    }
  }, {
    key: "googleLogin",
    value: function googleLogin() {
      window.location.href = "".concat(process.env.VUE_APP_AUTH_URL, "/google/login?target=").concat(process.env.VUE_APP_SYSTEM_NAME);
    }
  }, {
    key: "getOtherQuery",
    value: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
  }]);
}(Vue);
__decorate([Watch('$route', {
  immediate: true
})], default_1.prototype, "onRouteChange", null);
default_1 = __decorate([Component({
  name: 'Login',
  components: {
    LangSelect: LangSelect
  }
})], default_1);
export default default_1;